import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { Scheme, allSchemes } from '../../../shared/data/allSchemes';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import QRCode from 'qrcode';
import { EditorComponent, EditorModule } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { environment } from '../../../../environments/environment';
import { DialogModule } from 'primeng/dialog';
import { QRCodeComponent } from 'angularx-qrcode';
import { NgxPrintModule } from 'ngx-print';


@Component({
  selector: 'app-commenting-seet',
  standalone: true,
  imports:[CommonModule, FormsModule, DialogModule, QRCodeComponent, NgxPrintModule, EditorModule],
  templateUrl: './commenting-seet.component.html',
  styleUrl: './commenting-seet.component.scss',
  
})
export class CommentingSeetComponent implements OnInit {
  baseUrl=environment.APIUrl;
  @Input() id: any
  @Input() stepDetails: any
  @Input() type: any;
  @Input() url: string = '/transaction/comment-timeline/?proposal_step=';
  @Input() postUrl: string = '/transaction/proposal-comments/';
  @Output() isCommentSectionExpendChange: EventEmitter<boolean> = new EventEmitter();
  commentForm: FormGroup;
  init: EditorComponent['init'] = init;
  comment:string='';
  showPDODialog: boolean = false;


  constructor(private api: ApiService,private messageService: MessageService){

  }
  commentData: any;
  ngOnInit(): void {
   this.getCommentData();
  }
  getCommentData(id?:number){
    this.api.getAPI(`${this.url}${this.stepDetails?.id}`).subscribe((res: any) => {
      this.commentData = res.timeline;
      this.comment=''
      if(this.type) {this.openInternalComment(this.commentData[0]); return ;}
      if(this.commentKey === 2){
        this. closeInternalComment()
        return ;
      }
      if(id ){
        this.currentObject = this.commentData.find((item:any)=>item.id == id);
        this.openInternalComment(this.currentObject)
      }
    });
  }
 


  getFileIcon(filename: string): string {
    if (filename.endsWith('.pdf')) return 'fa-file-pdf text-rose-500';
    if (filename.endsWith('.xlsx')) return 'fa-file-excel text-emerald-600';
    if (filename.endsWith('.jpg')) return 'fa-file-image text-blue-500';
    return 'fa-file-alt text-slate-400';
  }
  
  currentObject: any;
  openInternalComment(item: any) {
    this.currentObject = {
      ...item,
      isCommentSectionExpend: true
    };

  }
  
  closeInternalComment() {
    if (this.currentObject) {
      this.currentObject.isCommentSectionExpend = false;
    }
  }


  // Helper function to get colors based on status
  getNumberColor(num: number): string {
    const n=num%10;
    switch (n) {
      case 1:  return 'bg-red-300 text-red-900 border-red-400';
      case 2:  return 'bg-orange-300 text-orange-900 border-orange-400';
      case 3:  return 'bg-amber-300 text-amber-900 border-amber-400';
      case 4:  return 'bg-yellow-300 text-yellow-900 border-yellow-400';
      case 5:  return 'bg-lime-300 text-lime-900 border-lime-400';
      case 6:  return 'bg-green-300 text-green-900 border-green-400';
      case 7:  return 'bg-emerald-300 text-emerald-900 border-emerald-400';
      case 8:  return 'bg-blue-300 text-blue-900 border-blue-400';
      case 9:  return 'bg-indigo-300 text-indigo-900 border-indigo-400';
      case 10: return 'bg-purple-300 text-purple-900 border-purple-400';
      default: return 'bg-slate-300 text-slate-900 border-slate-400';
    }
  }
  
  currentUserId: any = parseInt(sessionStorage.getItem('user_id') || '0');
  currentUnitId: any = parseInt(sessionStorage.getItem('unit_id') || '0');
  currentUserRoleCode: any = sessionStorage.getItem('user_role_code');
  submitComment(){
    // Prepare FormData for sending files (if any)
    const formData = new FormData();
    formData.append('comment', this.comment);
    formData.append('proposal_step', String(this.id));
    formData.append('user', String(this.currentUserId || sessionStorage.getItem('user_id') || '0'));
    formData.append('sequence', String(this.currentCMTobject.sequence));
    this.commentKey !== 2 ?formData.append('comment_turn', String(this.currentCMTobject.commentor_turn_id)):"";
    this.commentKey === 2 ?formData.append('is_main', "true"):''
    this.commentKey === 2 ?formData.append('comment_turn',this.currentCMTobject?.children[0]?.commentor_turn_id|| null):''
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      this.uploadedFiles.forEach((file, idx) => {
        formData.append('document', file); 
      });
    }
    this.api.postAPI(`${this.postUrl}`, formData).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment submitted' });
      this.getCommentData(this.currentCMTobject.id);
      this.showPDODialog = false;
    });
  }


  uploadedFiles: any[] = [];
  onFilesSelected(event: any) {
    this.uploadedFiles = Array.from(event.target.files);
  }
  commentKey: number = 0;
  getHeader(){
    switch(this.commentKey){
      case 0:
        return 'Add Internal Comment';
      case 1:
        return 'Edit Internal Comment';
      case 2:
        return 'Add Consolidated Comment';
      case 3:
        return 'Edit Consolidated Comment';
     default:
      return 'Add  Comment';
    }

  }
  currentCMTobject: any;
  openCommentBox(key,obj){
    this.commentKey = key;
    this.currentCMTobject =obj;
    this.showPDODialog = true;
  }

  // INSERT_YOUR_CODE
  getQrPayload(data) {
    return JSON.stringify({
      name: data?.name,
      hrcdf_designation: data?.hrcdf_designation,
      unit: data?.unit
    });
  }
  getFileNmae(file: string): string {
    return file.split('/').pop() || '';
  }

  }
